type ScrollViewport = Pick<HTMLElement, 'scrollTop' | 'scrollHeight' | 'clientHeight'>;

const LATEST_THRESHOLD = 32;

export function createTranscriptAutoFollow(onAwayChange: (away: boolean) => void) {
  let following = true;
  let userScrollIntent = false;
  let previousHeight = 0;
  let firstEventId: string | null = null;

  const atLatest = (viewport: ScrollViewport) =>
    viewport.scrollHeight - viewport.scrollTop - viewport.clientHeight <= LATEST_THRESHOLD;

  const follow = (viewport: ScrollViewport) => {
    viewport.scrollTop = viewport.scrollHeight;
    onAwayChange(false);
  };

  return {
    isFollowing: () => following,
    reset() {
      following = true;
      userScrollIntent = false;
      previousHeight = 0;
      firstEventId = null;
      onAwayChange(false);
    },
    userScrollUp(viewport: ScrollViewport) {
      userScrollIntent = true;
      if (viewport.scrollHeight > viewport.clientHeight) following = false;
    },
    userScrollDown() {
      userScrollIntent = true;
    },
    scrolled(viewport: ScrollViewport, dragging = false) {
      if (!userScrollIntent && !dragging) return;
      userScrollIntent = false;
      following = atLatest(viewport);
      onAwayChange(!following);
    },
    contentChanged(viewport: ScrollViewport, nextFirstEventId: string | null) {
      if (following) {
        follow(viewport);
      } else if (firstEventId && nextFirstEventId && firstEventId !== nextFirstEventId) {
        // Older pages insert above the current reading position.
        viewport.scrollTop += viewport.scrollHeight - previousHeight;
      }
      firstEventId = nextFirstEventId;
      previousHeight = viewport.scrollHeight;
    },
    resized(viewport: ScrollViewport) {
      if (following) follow(viewport);
      previousHeight = viewport.scrollHeight;
    },
    returnToLatest(viewport: ScrollViewport) {
      following = true;
      userScrollIntent = false;
      follow(viewport);
    },
  };
}
